import { useTranslation } from "react-i18next";
import DiscordIcon from "../../assets/images/social/discord.webp";
import TwitterIcon from "../../assets/images/social/twitter.webp";
import YoutubeIcon from "../../assets/images/social/youtube.webp";
import MediumIcon from "../../assets/images/social/medium.webp";
import DiscordSelectedIcon from "../../assets/images/social/discord-selected.webp";
import TwitterSelectedIcon from "../../assets/images/social/twitter-selected.webp";
import YoutubeSelectedIcon from "../../assets/images/social/youtube-selected.webp";
import MediumSelectedIcon from "../../assets/images/social/medium-selected.webp";
import FooterLogo from "../../assets/images/logos/large-logo.webp";
// import FooterSectionDivider from "../../assets/images/webp/footer_section_divider.webp";
// import sImage from "../../assets/images/webp/submit.webp";
import ssImage from "../../assets/images/webp/red-box.webp";
import titleline from "../../assets/images/webp/title_line.webp";


import { useFormik } from "formik";
import * as Yup from "yup";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

function Index() {
  const { t, i18n } = useTranslation();

    const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Not a proper email').required("Email is required"),
    }),
    onSubmit: (values) => {
      // setErrorText("");
      const payload = {
        email: values?.email,
      };
      fetch(process.env.REACT_APP_API_LINK +"/newsletter", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response?.status) {
            // setIsSuccess(true);
            confirmAlert({
      message:"Thank you for signup.",
      buttons: [
        {
          label: 'OK',
        },
      ]
    });
            formik.resetForm();
          } else {
          confirmAlert({
      message:response.message,
      buttons: [
        {
          label: 'OK',
        },
      ]
    });

            // setIsSuccess(false);
            // setErrorText(response.message);
          }
        })
        .catch((err) => {
          confirmAlert({
      message:err.message,
      buttons: [
        {
          label: 'OK',
        },
      ]
    });
          // setIsSuccess(false);
          // setErrorText(err.message);
        });
    },
  });

  return (
    <>
    <footer className="footer">
      <div className="container container-xxl">
        <div className="row ">
          <div className="col-lg-12">
            <div className="text-center footer-logo">
              <img src={FooterLogo} className="img-fluid" alt="" />
            </div>
            <div className="footer-newsletter">
              
              <div className="row ">
                <div className="col-lg-5 col-12 ">
                  <h4 className="title-text mt-3">
                      <span>{t('JOIN_THE')}</span>
                    {t('COMMUNITY')}
              {/* <span>{t("JOIN_THE")}</span>
              {t("COMMUNITY")} */}
                  </h4>
                  
                   {/* <div className="text-copyright">
                META LORDZ (C) {new Date()?.getFullYear()}{" "}
                {t("ALL_RIGHTS_RESERVED")}
              </div> */}

                  <div className="d-flex justify-content-center align-items-center mt-3">
                <div className="other-text">
                  <a
                        href={process.env.REACT_APP_PRIVACY_POLICY}
                        target={"_blank"}
                        >{t('Privacy Policy')}</a>
                  </div>
                <div className="other-section ms-2 me-2"></div>
                <div className="other-text">
                   <a
                        href={process.env.REACT_APP_TERMS_AND_CONDITIONS}
                        target={"_blank"}
                        >{t('Terms & Condition')}</a>
                  </div>
              </div>
                </div>
                <div className="col-lg-2 col-12">
                  <div className=" footer-sec-divider d-none d-lg-block"></div>
                </div>
                <div className="col-lg-4 col-10 m-auto">
<img src={titleline} alt="" width={'90%'} className="mt-4 mb-5 d-block d-lg-none" />
                    <h5 className="title-text text-center text-lg-start">
                    {t("SIGNUP_TO_OUR_NEWSLETTER")}
                  </h5>
                  <p className="text-center text-lg-start">{t("SIGNUP_TO_OUR_NEWSLETTER_INFO")}</p>
                    <form id="signup-link" onSubmit={formik.handleSubmit}>
                      
                     
<div className="input-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder={t("ENTER_YOUR_EMAIL_ADDRESS")}
                       onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                    style={{
                                      border:
                                        formik.touched.email &&
                                        formik.errors.email
                                          ? "2px solid #830d0d"
                                          : "2px solid #67522e",
                                    }}
                    />
                    <button type="submit" className="bg-transparent border-start-0 p-0">
                  <img src={ssImage} alt="" width={50} height={36} />
</button>
</div> 
                      
                    {/* <button className="btn-submit mt-4">{t("SUBMIT")}</button> */}
                  </form>

                  <img src={titleline} alt="" width={'90%'} className="mt-4 mb-4 mb-lg-5" />

                  <p className="text-center socaial-media">
                    {t("FOLLOW_US_ON_SOCIAL_MEDIA")}
                  </p>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        href={process.env.REACT_APP_DISCORD_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                            className="img-fluid"
                            src={DiscordIcon}
                            alt={"Discord"}
                          />
                          <img
                            className="img-fluid img-top" style={{left : 2}}
                            src={DiscordSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                    
                    <li>
                      <a
                        href={process.env.REACT_APP_YOUTUBE_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                            className="img-fluid"
                            src={YoutubeIcon}
                            alt={"Discord"}
                          />
                          <img
                            className="img-fluid img-top"
                            src={YoutubeSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={process.env.REACT_APP_TWITTER_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                            className="img-fluid w-75"
                            src={TwitterIcon}
                            alt={"Discord"}
                          />
                          <img
                            className="img-fluid img-top  w-75" style={{left : 5}}
                            src={TwitterSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href={process.env.REACT_APP_MEDIUM_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                            className="img-fluid"
                            src={MediumIcon}
                            alt={"Medium"}
                          />
                          <img
                            className="img-fluid img-top" style={{top : 2}}
                            src={MediumSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
      </footer>
      <div className="footer-border mt-1 pb-3"></div>
      </>
  );
}

export default Index;
